/**
 * t355u: opening an assistant source, an inline [n] or a link in an answer. A computer opens the cited (desktop) path;
 * a phone opens the phone screen for it (shared phoneSourceLink), and a person opens the person sheet.
 */
import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { phoneSourceLink, sourcePersonId } from '@tradeoutlet/shared';
import { useAuth } from '@/lib/auth';
import { useUi } from '@/lib/store';
import { useMobileLayout } from '@/mobile/layout';

export function useSourceLink() {
  const phone = useMobileLayout();
  const { userId } = useAuth();
  const nav = useNavigate();
  const openPerson = useUi(s => s.openPerson);
  const to = (link: string) => (phone ? phoneSourceLink(link, userId) : link);
  const open = (link: string) => {
    const t = to(link);
    const person = phone ? sourcePersonId(t) : null;
    if (person) openPerson(person); else nav(t);
  };
  /** For a <Link>: the href to show, and an onClick that opens a person as a sheet instead. */
  const linkProps = (link: string) => {
    const t = to(link);
    const person = phone ? sourcePersonId(t) : null;
    return { to: t, onClick: person ? (e: MouseEvent) => { e.preventDefault(); openPerson(person); } : undefined };
  };
  return { to, open, linkProps };
}
